
import { CheckCircle } from "lucide-react";

export const SuccessHeader = () => {
  return (
    <>
      <div className="flex justify-center mb-6">
        <CheckCircle className="h-16 w-16 text-green-500" />
      </div>
      <h1 className="text-3xl font-bold mb-4">Subscription Successful!</h1>
      <p className="text-gray-600 mb-6">
        Thank you for subscribing to the Pro plan. Your account has been upgraded, and you now have access to all Pro features.
      </p>
    </>
  );
};
